import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { BackButton } from '../../../../components/UI/ComponentsUI';
import { translate, formatData, enumText, isNullOrEmpty } from '../../../../utils/util';
import { formatJson, getUserNameToName } from '../../../../utils/util';
import { ENUMS } from '../../../../utils/constants';

const LogDetail = (props) => {
    const item = props.log || {};

    return (
        <div>
            <BackButton {...props} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '5px' }}>
                        <div className="row" style={{ marginBottom: '5' }}>
                            <div className="subtitle col s12" style={{ padding: '0px' }}>
                                <span className="field f-1r">{translate('log-details', 'stock')}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field no-padding col s12">
                                <span className="field f-1r">{item?.createdBy} - {getUserNameToName(props.usersFromElog, item?.createdBy)}</span>
                                <label className="active">{translate('createdBy', 'truck-kanban')}</label>
                            </div>
                        </div>
                        <div className="row">
                            {
                                !item?.success && (
                                    <div className="input-field no-padding col s12"  >
                                        <span className="field f-1r">{formatData(item.createdOn)}</span>
                                        <label className="active">{translate('line-picking:transmission.erro-send')}</label>
                                    </div>
                                )
                            }
                        </div>
                        <div className="row">
                            {
                                !isNullOrEmpty(item.operation) && item.operation !== 1 && (
                                    <div className="input-field no-padding col s12"  >
                                        <span className="field f-1r"> {translate(enumText(ENUMS.eStockOperation, item.operation || ''))}</span>
                                        <label className="active">{translate('line-picking:transmission.operation')}</label>
                                    </div>
                                )
                            }
                        </div>
                        <div className="row">
                            {
                                !isNullOrEmpty(item.orderCode) && (
                                    <div className="input-field no-padding col s12"  >
                                        <span className="field f-1r">{item.orderCode}</span>
                                        <label className="active">TD</label>
                                    </div>
                                )
                            }
                        </div>
                        <div className="row">
                            <div className="input-field no-padding col s12">
                                <pre className="field f-1r" style={{ padding: '0px' }}>{formatJson(item?.jsonRequest)}</pre>
                                <label className="active" htmlFor="nivel">JSON</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field no-padding col s12">
                                <pre className="field f-1r" style={{ padding: '0px' }}>{formatJson(item?.jsonResponse)}</pre>
                                <label className="active" htmlFor="nivel">{translate('response', 'truck-kanban')}</label>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        log: state.stockReducer.log,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = () => {
    return {
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogDetail)));
